import styled from 'styled-components';
import { colors } from '../colors';

interface sectionProps {
	margin?: string;
	padding?: string;
	textLeft?: string;
	textRight?: string;
	height?: string;
	width?: string;
	MinHeight?: string;
	overFlow?: string;
	marginBottom?: string;
	marginTop?: string;
	imgSlidePopup?: boolean;
	imgPreviewPopup?: boolean;
	searchSelectBlock?: boolean;
	tradeSearchBlock?: boolean;
	selectValue?: boolean;
	selectValueListing?: boolean;
	filterByDropdown?: boolean;
	filterSection?: boolean;
	generateDocumentFooter?: boolean;
	loginWrapper?: boolean;
	loginHeader?: boolean;
	loginBody?: boolean;
	loginFooter?: boolean;
	leftBlock?: boolean;
	rightBlock?: boolean;
	rightBlocksuccess?: boolean;
	loginBlock?: boolean;
	loginBlocksuccess?: boolean;
	homePageBannerBlock?: boolean;
	recentProjectsBlock?: boolean;
	projectsListBlock?: boolean;
	recentArchivesBlock?: boolean;
	recentSearchBlock?: boolean;
	changePasswordHolder?: boolean;
	bidPackageData?: boolean;
}
const Section = styled.div<sectionProps>`
	display: inline-block;
	position: relative;
	box-sizing: border-box;
	width: 100%;
	margin: ${({ margin }) => margin}!important;
	padding: ${({ padding }) => padding}!important;
	text-align: ${({ textLeft }) => textLeft}!important;
	text-align: ${({ textRight }) => textRight}!important;
	height: ${({ height }) => height}!important;
	width: ${({ width }) => width}!important;
	min-height: ${({ MinHeight }) => MinHeight}!important;
	margin-bottom: ${({ marginBottom }) => marginBottom}!important;
	margin-top: ${({ marginTop }) => marginTop}!important;
	overflow: ${({ overFlow }) => overFlow}!important;
	float: left;
	${({ imgSlidePopup }) =>
		imgSlidePopup &&
		`position:relative;
		display: flex;
		align-items: center;
		background: ${colors.BlueLight1};
		margin: 0 30px;
		width: calc(100% - 60px);
		height:100%;
		img{
			width: 100%;
			width: 100%;
			padding: 10px;
		}
		button{
			background: transparent;
			padding: 0;
			height: auto;
			img{
				width: auto;
				padding: 0;
			}
		}
	`}
	${({ imgPreviewPopup }) =>
		imgPreviewPopup &&
		`position:relative;
		display: flex;
		align-items: center;
		background: white;
		margin: 0 30px;
		width: calc(100% - 60px);
		height: 65vh;
		overflow-y: auto;
		img{
			width: 100%;
			padding: 10px;
		}
		button{
			background: transparent;
			padding: 0;
			height: auto;
			img{
				width: auto;
				padding: 0;
			}
		}
	`}
	${({ searchSelectBlock }) =>
		searchSelectBlock &&
		`flex-wrap: wrap;
		display:flex;
		margin: -10px 0 0 0;
		overflow: auto;
		max-height: 260px;
		padding: 3px 0 0 0;
		div{
			float: left;
			width: 100%;
			margin: 0 0 15px 0;
		}
	`}
	${({ tradeSearchBlock }) =>
		tradeSearchBlock &&
		`display:flex;
		align-items:center;
	`};
	${({ selectValue }) =>
		selectValue &&
		`display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 5px;
		width:100%!important;
		span{
			font-size: 8px;
		}
	`}
	${({ selectValueListing }) =>
		selectValueListing &&
		`width:100%;
	`}
	${({ filterSection }) =>
		filterSection &&
		`display: flex;
		align-items: center;
		justify-content: space-between;
		button{
			padding:0!important;
			margin:0!important;
			background: transparent!important;
		}
	`}
	${({ filterByDropdown }) =>
		filterByDropdown &&
		`width:auto;
		height:28px;
		border-radius: 18px;
		display: flex;
		align-items: center;
		background: ${colors.GreyF6};
		border: 1px solid  ${colors.GreyAB};
		.icon-filter{
			padding: 0 5px 0 12px;
			font-size: 13px;
		}
		div{
			font-size: 13px;
			line-height: 15px;
			padding: 0 13px 0 0;
			color: ${colors.Grey58};
		}
		.icon-arrow-down{
			width: 29px;
			text-align: center;
			justify-content: center;
			height: 27px;
			align-items: center;
			font-size: 5px;
			display:flex;
			border-left: 1px solid  ${colors.GreyAB};
			align-items:center;
		}
	`}
	${({ generateDocumentFooter }) =>
		generateDocumentFooter &&
		`margin:0;
		padding: 14px 24px;
		align-items: end;
		justify-content: flex-end;
		display: flex;
		border: 1px solid ${colors.GreyE1};
		background-color: ${colors.GreyF6};
		box-shadow: 0px -3px 7px rgba(0, 0, 0, 0.03);
		button{
			height: 34px;
			color: ${colors.White};
			font-size: 15px;
			line-height: 18px;
			font-family: 'RubikMedium'!important;
			background: ${colors.BlueDark};
			box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.03);
			border-radius: 18px;
		}
	`}
	${({ loginWrapper }) =>
		loginWrapper &&
		`width:100%;
		height:calc(100vh - 3px);
		background:;
		background:${colors.GreyEB};
	`}
	${({ loginHeader }) =>
		loginHeader &&
		`width:100%;
		height:75px;
		display:flex;
		padding:12px;
		// paddingLeft:25px;
		background:${colors.White};
		box-shadow: 0px 2px 6px #cad9ff;
	`}
	${({ loginBody }) =>
		loginBody &&
		`width:100%;
		height:auto;
		display:flex;
		align-items: center;
		justify-content: space-between;
		height: calc(100vh - 118px);
		padding:0 130px;
		@media (max-width:1160px){
			padding:0 50px;
			flex-wrap: nowrap;
		} 
		@media (max-width:860px){
			flex-direction: column;
			text-align: center;
			overflow: auto;
			height: calc(100vh - 86px);
			padding-top:20px;
		}
		@media (max-width:592px){
			padding:40px 10px 20px;
		} 
	`}
	${({ loginFooter }) =>
		loginFooter &&
		`width:100%;
		height:auto;
		color:${colors.Grey58};
		padding:32px 0;
		text-align:center;
		font-size: 13px;
		line-height: 15px;
		@media (max-width: 530px){
			padding:15px 0;
		}
	`}
	${({ leftBlock }) =>
		leftBlock &&
		`@media (max-width: 592px){
			display:none;
		}
	`}
	${({ rightBlock }) =>
		rightBlock &&
		`width:436px;
		@media (max-width: 992px){
			width:350px;
		}
		@media (max-width: 592px){
			width:100%;
		}
	`}
	${({ rightBlocksuccess }) =>
		rightBlocksuccess &&
		`width:736px;
		@media (max-width: 992px){
			width:650px;
		}
		@media (max-width: 592px){
			width:100%;
		}
`}
	${({ loginBlock }) =>
		loginBlock &&
		`width:436px;
		background:${colors.White};
		box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
		border-radius: 6px;
		padding: 56px 40px 40px;
		@media (max-width: 992px){
			width:350px;
		}
		@media (max-width: 860px){
			padding: 30px 40px 30px;
		}
		@media (max-width: 530px){
			width:100%;
			padding: 20px;
		}
	`}
	${({ loginBlocksuccess }) =>
		loginBlocksuccess &&
		`width:736px;
		background:${colors.White};
		box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
		border-radius: 6px;
		padding: 56px 40px 40px;
		text-align:center;
		@media (max-width: 992px){
			width:650px;
		}
		@media (max-width: 860px){
			padding: 30px 40px 30px;
		}
		@media (max-width: 530px){
			width:100%;
			padding: 20px;
		}
	`}
	
	${({ homePageBannerBlock }) =>
		homePageBannerBlock &&
		`width:100%;
		height:400px;
		background-color:${colors.Blue13};
		background-image: url("${require('../../assets/images/homeImg.svg')}");
		background-repeat: no-repeat;
		background-attachment: initial;
		background-position: center center;
		background-size: cover;
		display: flex;
		justify-content: center;
		align-items: flex-end;
	`}
	${({ projectsListBlock }) =>
		projectsListBlock &&
		`width:100%;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		
	`}
	${({ recentProjectsBlock }) =>
		recentProjectsBlock &&
		`width:100%;
		max-width:1170px;
		border-radius: 4px;
		background-color:${colors.White};
		padding:48px 20px 24px;
		min-height:200px;
		margin: -50px 0 0 0;
		h1{
			font-weight: 500;
			font-size: 22px;
			font-family: 'RubikMedium'!important;
			margin-top:10px;
		}
		p{
			font-weight: 500;
			font-size: 14px;
			font-family: 'RubikMedium'!important;
		}
		button{
			font-size: 13px;
			line-height: 15px;
			float: right;
			min-height: fit-content;
			font-family: 'RubikMedium'!important;
			margin: 29px 0 0 0!important;
			text-decoration: underline!important;
		}

	`}
	${({ recentArchivesBlock }) =>
		recentArchivesBlock &&
		`width:100%;
		max-width:1170px;
		border-radius: 4px;
		padding:0 20px 24px;
		min-height:200px;
		margin: 50px 0 0 0;
		h1{
			font-weight: 500;
			font-size: 22px;
			font-family: 'RubikMedium'!important;
			margin-top:10px;
		}
		p{
			font-weight: 500;
			font-size: 14px;
			font-family: 'RubikMedium'!important;
		}
		button{
			font-size: 13px;
			line-height: 15px;
			float: right;
			min-height: fit-content;
			font-family: 'RubikMedium'!important;
			margin: 29px 0 0 0!important;
			text-decoration: underline!important;
		}
	`}

	${({ changePasswordHolder }) =>
		changePasswordHolder &&
		`height: calc(100vh - 67px);
		display: flex;
		align-items: center;
		justify-content: center;
	`}
	${({ bidPackageData }) =>
		bidPackageData &&
		`margin-top:-30px;
		align-items:center;
		margin-right:-30px;
		
	`};
`;
export default Section;
